import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';

// 创建axios实例
const request: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api', // 从环境变量获取baseURL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 从URL获取token
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    // 如果存在token，添加到请求头
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response: AxiosResponse) => {
    const res = response.data;
    
    // 这里可以根据后端的响应结构进行统一处理
    if (res.code !== 0) {
      // 处理业务错误
      const error = new Error(res.message || '请求失败') as Error & { code?: number };
      error.code = res.code;
      return Promise.reject(error);
    }
    
    return res.data;
  },
  (error) => {
    // 处理HTTP错误
    let message = '网络请求失败';
    if (error.response) {
      switch (error.response.status) {
        case 401:
          message = '未登录或登录已过期';
          // 这里可以添加重定向到登录页的逻辑
          break;
        case 403:
          message = '没有权限访问';
          break;
        case 404:
          message = '请求的资源不存在';
          break;
        case 500:
          message = '服务器错误';
          break;
        default:
          message = `请求失败 (${error.response.status})`;
      }
    } else if (error.request) {
      message = '服务器无响应';
    }
    
    const customError = new Error(message);
    return Promise.reject(customError);
  }
);

// 封装通用请求方法
export const http = {
  get: <T = any>(url: string, config?: AxiosRequestConfig): Promise<T> => {
    return request.get(url, config);
  },
  
  post: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> => {
    return request.post(url, data, config);
  },
  
  put: <T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> => {
    return request.put(url, data, config);
  },
  
  delete: <T = any>(url: string, config?: AxiosRequestConfig): Promise<T> => {
    return request.delete(url, config);
  }
};

// 支付相关的API封装
export const paymentApi = {
  // 创建支付订单
  createOrder: (data: {
    levelId: number;
    paymentMethod: string;
    amount: number;
  }) => {
    return http.post<{
      orderId: string;
      paymentUrl?: string;
    }>('/payment/create', data);
  },
  
  // 查询支付状态
  queryOrderStatus: (orderId: string) => {
    return http.get<{
      status: 'pending' | 'success' | 'failed';
      message?: string;
    }>(`/payment/status/${orderId}`);
  },
  
  // 取消支付
  cancelOrder: (orderId: string) => {
    return http.post(`/payment/cancel/${orderId}`);
  }
};



export default request; 